import React, { useMemo, useState } from 'react';
import { Card, Form, Button } from 'react-bootstrap';
import { ArrowLeftCircleFill, ArrowRightCircleFill } from 'react-bootstrap-icons';
import useLocalization from '../../hooks/useLocalization';
import InputCell from '../common/overview-columns/InputCell';
import { editMultipleApartmentsFields } from '../../helpers/overviewColumnsFields';
import { Spinner } from 'react-bootstrap';

const UpdateMultipleAppartmentSidebar = ({ setShowMultiEditSidebar, assigneUsers, onFieldValueSave }) => {
  const { translate, isRTL } = useLocalization();
  const [formData, setFormData] = useState({
    status: '',
    realEstateAnalyst: ''
  });
  const [loadingField, setLoadingField] = useState([]);

  const updateMultipleApartmentsFields = useMemo(
    () => editMultipleApartmentsFields({ users: assigneUsers, translate }),
    [assigneUsers, translate]
  );

  const handleFieldUpdate = async (fieldKey, fieldValue) => {
    setLoadingField(prev => [...prev, fieldKey]);
    await onFieldValueSave({
      apartmentUpdates: {
        [fieldKey]: fieldValue
      }
    });
    setLoadingField(prev => prev.filter(key => key !== fieldKey));
  };
  const onFieldChange = (field, value) => {
    let newFormData = { ...formData };
    newFormData = { ...formData, [field.key]: value };
    setFormData({ ...newFormData });
  };

  return (
    <Card
      className={`rounded-0 position-absolute ${isRTL ? 'end-0' : 'start-0'} d-flex flex-column`}
      style={{
        width: '20%',
        top: 0,
        height: '100%',
        zIndex: 10,
        backgroundColor: 'white'
      }}
    >
      <Card.Header className="bg-white d-flex justify-content-between align-items-center flex-shrink-0">
        <h6 className="smallFont fw-bold mt-2">{translate('edit_multiple_apartment_field')}</h6>
        {!isRTL ? (
          <ArrowLeftCircleFill className="hover" size={16} onClick={() => setShowMultiEditSidebar(false)} />
        ) : (
          <ArrowRightCircleFill className="hover" size={16} onClick={() => setShowMultiEditSidebar(false)} />
        )}
      </Card.Header>
      <Card.Body>
        {updateMultipleApartmentsFields.map(field => (
          <Form.Group key={field.key} className="mb-3">
            <div className="d-flex align-items-center justify-content-between my-2">
              <Form.Label onClick={() => null} className="m-0 p-0 fw-bold smallFont">
                {translate(field.label) || field.label}
              </Form.Label>
              <Button
                disabled={
                  formData[field.key] === null ||
                  formData[field.key] === undefined ||
                  formData[field.key] === '' ||
                  (Array.isArray(formData[field.key]) && formData[field.key].length === 0) ||
                  loadingField.includes(field.key)
                }
                className="py-0 px-1 d-flex align-items-center"
                size="sm"
                variant="success text-white"
                onClick={() => handleFieldUpdate(field.key, formData[field.key])}
              >
                <span className="text-white tiny">{translate('replace')}</span>&nbsp;&nbsp;
                {loadingField.includes(field.key) && <Spinner animation="border" size="sm" />}
              </Button>
            </div>
            <InputCell field={field} data={formData} formControlType={field.type} onChange={onFieldChange} />
          </Form.Group>
        ))}
      </Card.Body>
    </Card>
  );
};

export default UpdateMultipleAppartmentSidebar;
